import { getAuditTemplate, OperationObjects } from '../script/audit_utils';
import {
  getOperationAuditList,
  createOperationAuditLog,
  updateOperationAuditLog
} from '../server/ofbiz/operationAudit';

export const SET_OPERATION_AUDIT_DATA = 'SET_OPERATION_AUDIT_DATA';

export function setOperationAuditData(operationAuditData) {
  return {
    type: SET_OPERATION_AUDIT_DATA,
    operationAuditData
  }
}

// 操作审计模块：已切换到 OFBiz 新接口（json/operationAudit/list|create|update）。
// 新后端基于 NoteData(OPLOG) 存储，前端在此层做新旧契约映射，
// 上层组件（operationalAuditTable 等）与调用方逻辑保持不变。

// 成败判定：'0' 或 文本含「失败」视为失败，与表格 checkFailRecord 口径一致
function toAuditStatus(results) {
  const s = results == null ? '' : String(results);
  return (s === '0' || s.indexOf('失败') > -1) ? 'FAIL' : 'SUCCESS';
}

// 获取操作审计数据
// param（旧契约查询条件）：{startTime, endTime, operationObject, operationType, operationResult}
// 回调：成功 callback(1)，失败 callback(0)——回调值会被调用方当作 OperationResults 再记一条审计
export function getOperationAuditData(param, callback) {
	return dispatch => {
    const p = param || {};
    const params = {
      startTime: p.startTime || '',
      endTime: p.endTime || '',
      // 操作对象：旧小写 key -> 后端 module（中文名精确匹配，与存储口径一致）
      module: p.operationObject ? (OperationObjects[p.operationObject] || '') : '',
      // 操作类型：小写 key 原样（存储时即用小写 key）
      operationType: p.operationType || '',
      status: p.operationResult === '1' ? 'SUCCESS' : p.operationResult === '0' ? 'FAIL' : '',
      // 表格为前端本地分页，一次拉取（后端单页上限 500）
      page: 1,
      pageSize: 500,
    };
    getOperationAuditList(params).then(({ list }) => {
      dispatch(setOperationAuditData(list || []));
      callback && callback(1);
    }).catch(() => {
      dispatch(setOperationAuditData([]));
      callback && callback(0);
    });
	}
}

//添加操作审计记录
// param（旧契约）：{type, BoId, desc, OperationAssociation, OperationResults(1/0/文本)}
export function createOperationAudit(param, callback) {
	return dispatch => {
    // getAuditTemplate 转换为 {OperationType, OperationBo, OperationDesc, OperationAssociation}
    // 注意其副作用会 delete param.desc / param.reportType
    const template = getAuditTemplate(param);
    const raw = param.OperationResults == null ? '' : String(param.OperationResults);
    // 描述优先用调用方显式传的 OperationDesc（如登录 "xxx登录"），否则用模板拼接结果
    let description = param.OperationDesc || template.OperationDesc || '';
    // 结果是文本消息（非 '1'/'0'）时拼入描述，保留失败/结果原因
    if (raw && raw !== '1' && raw !== '0') {
      description += `；结果：${raw}`;
    }
    createOperationAuditLog({
      module: template.OperationBo || '',
      operationType: template.OperationType || '',
      description: description,
      association: param.OperationAssociation || template.OperationAssociation || '',
      status: toAuditStatus(param.OperationResults),
    }).then(record => {
      // 旧契约回调返回记录 ID（供 updateOperationAudit 引用）
      callback && callback(record && (record.noteId || record.RecId));
    }).catch(() => {
      // 审计记录失败不阻断业务，静默回调
      callback && callback();
    });
  }
}

//修改操作审计记录
// params（旧契约）：{RecId, OperationResults}
export function updateOperationAudit(params, callback){
	return dispatch => {
    if (!params || !params.RecId) {
      callback && callback();
      return;
    }
    updateOperationAuditLog({
      noteId: params.RecId,
      status: toAuditStatus(params.OperationResults),
    }).then(() => {
      callback && callback(1);
    }).catch(() => {
      callback && callback();
    });
  }
}
